import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromMetworkLogger from './network-logger.reducer';
import { NetworkLoggerEffects } from './network-logger.effects';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [
    StoreModule.forFeature(fromMetworkLogger.networkLoggerFeatureKey, fromMetworkLogger.reducer),
    EffectsModule.forFeature([NetworkLoggerEffects]),
  ],
})
export class NetworkLoggerModule {}
